import React, { useRef } from "react";
import {
  FaShoppingCart,
  FaGraduationCap,
  FaBook,
  FaPencilAlt,
  FaUsers,
  FaStar,
  FaShoppingBag,
  FaWhatsapp,
  FaResearchgate,
  FaFlask,
} from "react-icons/fa";
import styles from "./Shop.module.css";

import Playtrons from "../../assets/images/shop/StemXRoboticsAndAi.png";
import electronics from "../../assets/images/shop/StemXElectronics.png";
import Arduino from "../../assets/images/shop/StemXArduino.png";
import drone from "../../assets/images/shop/drone.jpg";
import modelling from "../../assets/images/shop/AeroModelling.jpg";
import latheMachine from "../../assets/images/shop/LatheMachine.jpg";
import SafetyTools from "../../assets/images/shop/SafetyTools.jpg";
import arvr from "../../assets/images/shop/arvr.jpg";
import clayPottery from "../../assets/images/shop/clayPottery.jpg";
import humanoid from "../../assets/images/shop/humanoid.jpg";
import laserCutter from "../../assets/images/shop/laserCutter.jpg";
import legoWall from "../../assets/images/shop/legoWall.jpg";
import pen from "../../assets/images/shop/pen.jpg";
import printing from "../../assets/images/shop/printing.jpg";
import solderingStation from "../../assets/images/shop/solderingStation.jpg";
import telescope from "../../assets/images/shop/telescope.jpg";
import toolsAndPegBoard from "../../assets/images/shop/toolsAndPegBoard.jpg";
import Playmex from "../../assets/images/shop/Playmex.jpg";
import ZingHumanoid from "../../assets/images/shop/Zing Humanoid.jpg";
import Hexapod from "../../assets/images/shop/Hexapod.jpg";
import RoboticArm from "../../assets/images/shop/Robotic Arm.jpg";
import DogRobot from "../../assets/images/shop/Dog Robot.jpg";
import PEECEE from "../../assets/images/shop/PEECEE.jpg";
import PlayDynamics from "../../assets/images/shop/PlayDynamics.jpg";
import planetarium from "../../assets/images/shop/planetorium.png";

const schoolSupplies = [
  {
    id: 1,
    name: "STEMx Playmex Kit for Grades 1 and 2",
    cost: 12999,
    image: Playmex,
    description: "Robotics & Simple mechanism kit",
    whatsappNumber: "917259981441",
  },
  {
    id: 2,
    name: "STEMx Electronics Kit For Juniors",
    cost: 8900,
    image: Playtrons,
    description: "Electronics building blocks kit",
    whatsappNumber: "917259981441",
  },
  {
    id: 3,
    name: "STEMx PlayDynamics Kit for Grades 3 to 5",
    cost: 15999,
    image: PlayDynamics,
    description: "Robotics and Advanced mechanism kit",
    whatsappNumber: "917259981441",
  },
  {
    id: 4,
    name: "STEMx Electronics Kit For Seniors",
    cost: 9600,
    image: electronics,
    description: "Raw electronics blocks with science integration",
    whatsappNumber: "917259981441",
  },
  {
    id: 5,
    name: "STEMx PEECEE AI Kit for Grades 6 to 10",
    cost: 19999,
    image: PEECEE,
    description: "Kit for exploring AI features in school level",
    whatsappNumber: "917259981441",
  },
  {
    id: 6,
    name: "STEMx Zing Humanoid for Grades 8 to 12",
    cost: 78000,
    image: ZingHumanoid,
    description: "Humanoid that can be used for R&D & code by GUI & python",
    whatsappNumber: "917259981441",
  },
  {
    id: 7,
    name: "STEMx Hexapod for Grades 8 to 12",
    cost: 84000,
    image: Hexapod,
    description: "Spider bot that can be used for R&D & code by GUI & python",
    whatsappNumber: "917259981441",
  },
  {
    id: 8,
    name: "STEMx Robotic Arm for Grades 8 to 12",
    cost: 54000,
    image: RoboticArm,
    description: "Robotic Arm that can be used for R&D & code by GUI & python",
    whatsappNumber: "917259981441",
  },
  {
    id: 9,
    name: "5.5 Feet Humanoid Robot for Grades 5 to 12",
    cost: 680000,
    image: humanoid,
    description: "Humanoid that can be co-teacher & receptionist",
    whatsappNumber: "917259981441",
  },
  {
    id: 10,
    name: "STEMx Dog Robot for Grades 8 to 12",
    cost: 780000,
    image: DogRobot,
    description:
      "Quadruped that can be used for R&D & Industrial applications in schools/colleges",
    whatsappNumber: "917259981441",
  },
  {
    id: 11,
    name: "STEMx Doom Planetarium",
    cost: 630000,
    image: planetarium, // Add appropriate image path
    description:
      "Explore wide range of Space curriculum with group of 40 members in doom",
    whatsappNumber: "917259981441",
  },
  {
    id: 12,
    name: "3D Pen for Grades 1 to 4",
    cost: 6500,
    image: pen,
    description: "Shapes come live with 3D designing",
    whatsappNumber: "917259981441",
  },
  {
    id: 13,
    name: "Aeromodelling Kit for Grades 3 to 12",
    cost: 2200,
    image: modelling,
    description:
      "Build and fly long distance Aeroplanes & Rockets with wood made",
    whatsappNumber: "917259981441",
  },
  {
    id: 14,
    name: "Arduino kit",
    cost: 11200,
    image: Arduino,
    description:
      "Core open source electronics & IOT kit for exploring various STEM Projects",
    whatsappNumber: "917259981441",
  },
  {
    id: 15,
    name: "3D Printing Kit for Grades 5 to 12",
    cost: 54000,
    image: printing,
    description: "Think, Design and 3D Print any product",
    whatsappNumber: "917259981441",
  },
  {
    id: 16,
    name: "Drone Tool Kit for Grades 5 to 12",
    cost: 12400,
    image: drone,
    description:
      "Build, Code, Test and Fly the drone and learn its industry applications",
    whatsappNumber: "917259981441",
  },
  // Remaining items with no specific order
  {
    id: 17,
    name: "Safety Tools for Grades 6 to 12",
    cost: 5200,
    image: SafetyTools,
    description: "Safety is more important in Tinkering & research",
    whatsappNumber: "917259981441",
  },
  {
    id: 18,
    name: "Soldering Station for Grades 6 to 12",
    cost: 3200,
    image: solderingStation,
    description:
      "For troubleshooting, Soldering & Research done easy using soldering station",
    whatsappNumber: "917259981441",
  },
  {
    id: 19,
    name: "Clay Pottery Wheel for Grades 3 to 12",
    cost: 46500,
    image: clayPottery,
    description:
      "Create beautiful pottery with this hands-on clay pottery wheel.",
    whatsappNumber: "917259981441",
  },
  {
    id: 20,
    name: "Telescope for Grades 5 to 12",
    cost: 12800,
    image: telescope,
    description: "Explore the universe with this high-quality telescope.",
    whatsappNumber: "917259981441",
  },
  {
    id: 21,
    name: "LEGO Wall for Grades 1 to 12 (4 feet by 6 feet)",
    cost: 30000,
    image: legoWall,
    description:
      "A creative space for students to build and showcase their LEGO creations.",
    whatsappNumber: "917259981441",
  },
  {
    id: 22,
    name: "Mini Lathe Machine for Grades 8 to 12",
    cost: 39800,
    image: latheMachine,
    description:
      "Precision mini lathe machine for crafting and engineering projects.",
    whatsappNumber: "917259981441",
  },
  {
    id: 23,
    name: "Laser Cutter for Grades 8 to 12",
    cost: 42000,
    image: laserCutter,
    description: "Cut and engrave materials with this advanced laser cutter.",
    whatsappNumber: "917259981441",
  },
  {
    id: 24,
    name: "3D Pen for Grades 1 to 4",
    cost: 6500,
    image: pen,
    description: "Bring your ideas to life with this easy-to-use 3D pen.",
    whatsappNumber: "917259981441",
  },
];
const stats = [
  { icon: <FaUsers />, value: "1.2Lakh+", label: "Happy Students" },
  {
    icon: <FaFlask />,
    value: "240+",
    label: "Lab Setups",
  },
  { icon: <FaStar />, value: "4.8", label: "Average Rating" },
  { icon: <FaShoppingBag />, value: "24/7", label: "Support" },
];

const Shop = () => {
  const productsRef = useRef(null); // Create a ref for the products section

  const handleWhatsAppClick = (product) => {
    const message = `Hi! I'm interested in buying ${product.name} for Rs. ${product.cost}`;
    const encodedMessage = encodeURIComponent(message);
    
    // Check if user is on mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    // Choose appropriate URL based on device
    const whatsappUrl = isMobile
      ? `https://wa.me/${product.whatsappNumber}?text=${encodedMessage}`
      : `https://web.whatsapp.com/send?phone=${product.whatsappNumber}&text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
  };

  const scrollToProducts = () => {
    if (productsRef.current) {
      productsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className={styles.container}>
      <section className={styles.hero}>
        <div className={styles.content}>
          <div className={styles.mainContent}>
            <h1>
              Your One-Stop
              <span className={styles.highlight}>School Supply Shop</span>
            </h1>
            <p>
              Get everything you need for your academic success with our premium
              quality school supplies. From Robotics kits, 3d printers,
              electronics kits, drones, AR/VR headsets & electronics kits, we've
              got you covered!
            </p>
            <div className={styles.buttons}>
              <button className={styles.primary} onClick={scrollToProducts}>
                <FaShoppingBag /> Shop Now
              </button>
            </div>
          </div>

          <div className={styles.statsGrid}>
            {stats.map((stat, index) => (
              <div key={index} className={styles.quickStat}>
                <div className={styles.statIcon}>{stat.icon}</div>
                <div className={styles.statValue}>{stat.value}</div>
                <div className={styles.statLabel}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.productsSection} ref={productsRef}>
        <h2 className={styles.sectionTitle}>
          <FaBook /> Featured Products
        </h2>

        <div className={styles.productGrid}>
          {schoolSupplies.map((product) => (
            <div key={product.id} className={styles.productCard}>
              <img
                src={product.image}
                alt={product.name}
                className={styles.productImage}
              />
              <div className={styles.productContent}>
                <h3 className={styles.productTitle}>{product.name}</h3>
                <p className={styles.productDescription}>
                  {product.description}
                </p>
                <div className={styles.price}>₹{product.cost}</div>
                <button
                  onClick={() => handleWhatsAppClick(product)}
                  className={styles.whatsappButton}
                >
                  <div className={styles.icon}>
                    <FaWhatsapp />
                  </div>
                  Buy on WhatsApp
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Shop;
